import * as types from "./mutations-type";
export default{
   
    [types.SET_TOMADOR](state,payload){
        state.tomador = payload
    },
    
}